export default class Maze {
    constructor(grid) {
        this.grid = grid;
    }
    static basicMaze(width, height) {
        let grid = [];
        for (let i = 0; i < height; i++) {
            const row = [];
            for (let j = 0; j < width; j++) {
                if (i == 0 || i == height - 1 || j == 0 || j == width - 1)
                    row.push(1);
                else
                    row.push(0);
            }
            grid.push(row);
        }
        return new Maze(grid);
    }
    isValid() {
        let robots = 0;
        for (let i = 0; i < this.height(); i++) {
            for (let j = 0; j < this.width(); j++) {
                if (this.grid[i][j] == 2) {
                    robots++;
                }
            }
        }
        return robots == 1;
    }
    findPlayer() {
        for (let i = 0; i < this.height(); i++) {
            for (let j = 0; j < this.width(); j++) {
                if (this.grid[i][j] == 2) {
                    return [j, i];
                }
            }
        }
        return null;
    }
    width() {
        return this.grid[0].length;
    }
    height() {
        return this.grid.length;
    }
    isUnique(x, y) {
        if (x == 0 && y == this.height() - 1)
            return true;
        if (y == 0 || x == this.width() - 1 || this.grid[y - 1][x + 1] != 1)
            return false;
        const [uniqueX, uniqueY] = this.findUniquePoint(x + 1, y - 1);
        return uniqueX == x + 1 && uniqueY == y - 1;
    }
    findUniquePoint(x, y) {
        const initial = [x, y];
        const queue = [initial];
        const seen = new Set();
        seen.add(initial.toString());
        let uniqueX = x;
        let uniqueY = y;
        while (queue.length != 0) {
            const [a, b] = queue.pop();
            if (b > uniqueY || (b == uniqueY && a < uniqueX)) {
                uniqueX = a;
                uniqueY = b;
            }
            // Enqueue neighbours
            this.enque(seen, queue, a - 1, b - 1);
            this.enque(seen, queue, a - 1, b);
            this.enque(seen, queue, a - 1, b + 1);
            this.enque(seen, queue, a, b - 1);
            this.enque(seen, queue, a, b);
            this.enque(seen, queue, a, b + 1);
            this.enque(seen, queue, a + 1, b - 1);
            this.enque(seen, queue, a + 1, b);
            this.enque(seen, queue, a + 1, b + 1);
        }
        return [uniqueX, uniqueY];
    }
    enque(seen, queue, x, y) {
        if (x < 0 || x >= this.width() || y < 0 || y >= this.height())
            return;
        if (this.grid[y][x] != 1)
            return;
        if (!seen.has([x, y].toString())) {
            seen.add([x, y].toString());
            queue.push([x, y]);
        }
    }
    clone() {
        let grid = [];
        for (const row of this.grid) {
            grid.push([...row]);
        }
        return new Maze(grid);
    }
}
